/** Key holding the free-text search query, in `activeFilters` and in the URL. */
export const SEARCH_KEY = 'search';

/**
 * Key holding the field the free-text search runs against, in `activeFilters`
 * and in the URL. Technical companion of `search`, never a filter of its own.
 */
export const SEARCH_TARGET_KEY = 'searchTarget';
